<template>
    <div class="space-y-4">
        <h1 class="text-2xl font-semibold tracking-wider">Dashboard</h1>
        <div class="md:flex gap-4 py-4">
            <div class="md:w-1/2 space-y-4 bg-white border rounded-md p-8">
                <h1 class="text-lg tracking-wide">Job Posts by Job Type</h1>
                <hr />
                <div
                    v-if="Object.keys(jobsByJobType).length > 0"
                    class="flex justify-between items-center"
                    v-for="(value, key, index) in jobsByJobType"
                    :key="index"
                >
                    <p class="text-gray-500">
                        {{ key }}
                    </p>
                    <p
                        class="bg-blue-600 text-white font-bold px-4 py-2 rounded-md"
                    >
                        {{ value }}
                    </p>
                </div>
                <div v-else>
                    <small>You haven't post any job yet.</small>
                </div>
            </div>

            <div class="md:w-1/2 space-y-4 bg-white border rounded-md p-8">
                <h1 class="text-lg tracking-wide">Active Jobs</h1>
                <hr />
                <div class="flex justify-start">
                    <p
                        class="text-5xl bg-blue-600 text-white font-bold px-4 py-2 rounded-md"
                    >
                        {{ totalJobs }}
                    </p>
                </div>
            </div>

            <div class="md:w-1/2 space-y-4 bg-white border rounded-md p-8">
                <h1 class="text-lg tracking-wide">Total Applications</h1>
                <hr />
                <div class="flex justify-start">
                    <p
                        class="text-5xl bg-blue-600 text-white font-bold px-4 py-2 rounded-md"
                    >
                        0
                    </p>
                </div>
            </div>
        </div>

        <div class="">
            <div class="w-full h-96 bg-white border rounded-md p-8">
                <p>graph goes here</p>
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    totalJobs: Object,
    jobsByJobType: Object,
});

const { totalJobs, jobsByJobType } = props;
</script>

<style></style>
